<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Exportar - Dropbox</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }}</h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()">
            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Caminho Dropbox</label>
                <input type="text" id="fullpath" class="form-control" formControlName="fullpath" required placeholder="/(nome_arquivo_destino).csv" />
                <app-field-message [field]="fieldMessageRequired('fullpath')" [erros]="fieldErros('fullpath')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Tipo de arquivo</label>
                <ng-select id="type_id" class="ng-select-alternative" (change)="atualizaFilename()" [items]="typeList" bindLabel="label" placeholder="Selecione o tipo de arquivo" formControlName="type_id">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('type_id')" [erros]="fieldErros('type_id')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Nome de sistema</label>
                <input type="text" id="filename" class="form-control" formControlName="filename" />
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Modo de envio</label>
                <ng-select id="execution_id" class="ng-select-alternative" [items]="executionList" bindLabel="label" bindValue="id" placeholder="Selecione o modo de envio" formControlName="execution_id">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('execution_id')" [erros]="fieldErros('execution_id')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>